<template>
  <div class="tender-chapter">
    <!-- <h2 class="tc-title tender-site-title">{{chapter.Title}}</h2> -->
    <tender-section v-for="(section, i) in sections" :key="i"
      :chapter-index="chapterIndex"
      :section-index="i"
      :ref="setSectionRef"
    ></tender-section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TenderSection from './tender-section'
export default {
  name: 'TenderChapter',
  components: {
    TenderSection
  },
  props: {
    chapterIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sectionRefs: []
    }
  },
  beforeUpdate() {
    this.sectionRefs = []
  },
  computed: {
    ...mapGetters(['chapters']),
    chapter() {
      return this.chapters[this.chapterIndex]
    },
    sections() {
      return this.chapter.Sections
    }
  },
  methods: {
    async validate () {
      let promises = this.sectionRefs.map(section => section.validate())
      return await Promise.all(promises)
    },
    setSectionRef(el) {
      if(el) {
        this.sectionRefs.push(el)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tender-chapter {
  width: 900px;
  margin: 0 auto;
  box-sizing: border-box;
  .tc-title {
    font: bold 25px/30px simsun;
    text-align: center;
  }
}
</style>